module.exports = "<section id=\"calendario\" data-aos=\"fade-up\" data-aos-anchor-placement=\"center-bottom\">\n  <br/>\n  <div id=\"calendar\"></div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/portal-cmcti/cm-cti/cm-cti.component.html
// module id = ./src/app/portal-cmcti/cm-cti/cm-cti.component.html
// module chunks = main